import React, { Fragment, useEffect, useState } from 'react';
import { AppBar, Button, ClickAwayListener, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, IconButton, ListItemText, MenuItem, MenuList, Paper, Snackbar, Switch, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WhatsappLogo from '../../../../../images/wa-svg.jpg';
import Avatar from '@material-ui/core/Avatar';
import SubjectIcon from '@material-ui/icons/Subject';
import moment from 'moment';
import PersonIcon from '@material-ui/icons/Person';
import Alert from '@material-ui/lab/Alert';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';

const useStyle = makeStyles(theme => ({
	root: {
		width: '380px',
		marginTop: theme.spacing(1)
	},
	card: {
		padding: theme.spacing(1, 0.3, 0.5, 2),
		margin: theme.spacing(1)
	},
	row: {
		display: 'flex',
		'flex-direction': 'row',
	}
}));
export default function TicketDetailModal({ ticketDetails }) {
	const classes = useStyle();
	const [open, setOpen] = useState(false);
	const [snackbaropen, setSnackBarOpen] = useState(false);
	const [dropDownOpen, setDropDownOpen] = useState(false);

	let user = JSON.parse(localStorage.getItem('user_data'));

	useEffect(() => {
		if (ticketDetails) {
			setOpen(true)
		}
	}, [ticketDetails]);

	return (
		<>
			<Snackbar
				style={{ marginRight: '80px' }}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				open={snackbaropen}
				autoHideDuration={300}
				onClose={!snackbaropen}
			>
				<Alert variant="filled" severity={'success'}>
					{'Copied To Clipboard'}
				</Alert>
			</Snackbar>
			<div>
				<ClickAwayListener>
					<Dialog
						open={open}
						onClose={() => {
							setOpen(false);
						}}
						className={classes.notificationDialogContainer}
						fullWidth={true}
					>
						<AppBar position="static" elevation={1}>
							<div
								className="flex flex-col items-center justify-center pb-10 text-20 align-items-center"
								style={{ paddingBottom: 4, paddingTop: 4 }}
							>
								<h1 color="primary">Complain Details</h1>
							</div>
						</AppBar>
						<DialogTitle style={{ padding: '20px 60px 0' }}></DialogTitle>
						<DialogContent>
							<div>
								<div style={{ marginTop: '10px' }} className={classes.row}>
									<Avatar sx={{ width: 10, height: 10 }} />

									<h3 style={{ marginLeft: '10px', marginTop: '5px' }}>{ticketDetails?.name}</h3>
									{ticketDetails?.channel_type ? (
										<Avatar
											src={WhatsappLogo}
											style={{
												borderRadius: '50%',
												height: '25px',
												width: '25px',
												marginLeft: '12px',
												marginTop: '5px'
											}}
										/>
									) : null}
								</div>
							</div>
							<div className={classes.row}>
								<span
									style={{ marginTop: '5px', marginLeft: '50px', cursor: 'pointer' }}
									onClick={() => {
										navigator.clipboard.writeText(ticketDetails?.ticket_number);
										setSnackBarOpen('true');
										setTimeout(() => {
											setSnackBarOpen(false);
										}, 1000);
									}}
								>
									Ticket Number: {ticketDetails?.ticket_number}
								</span>
									<div style={{ position: 'relative', height: 'auto', marginLeft: '15%' }}>
										<span style={{ position: 'absolute' }}>
											<div className={classes.row}>
												<ViewColumnIcon />
												<p
													style={{
														marginRight: '5px',
														marginTop: '3px',
														// cursor: 'pointer',
														fontSize: '13px'
													}}
												>
													{ticketDetails?.status}
												</p>
											</div>
										</span>
									</div>
							</div>
							<div style={{ width: '100%' }} onClick={() => setDropDownOpen(false)}>
								<div style={{ marginTop: '30px' }} className={classes.row}>
									<SubjectIcon />
									<h3 style={{ marginLeft: '10px' }}>Description</h3>
								</div>
							</div>

							<br />
							<br />
							<div style={{ width: '100%' }} onClick={() => setDropDownOpen(false)}>
								<TextField
									label="Complain"
									fullWidth
									disabled="true"
									variant="outlined"
									value={ticketDetails?.customer_message}
									multiline
									size="small"
									inputProps={{ maxLength: 800 }}
									rowsMax={6}
								/>
							</div>
							<div
								style={{ marginTop: '20px', width: '100%',alignItems:"center" }}
								className={classes.row}
								onClick={() => setDropDownOpen(false)}
							>
								<PersonIcon />
								<p style={{ marginLeft: '5px', fontSize: '12px' }}>{ticketDetails?.name} added this complain</p>
								<p style={{ marginLeft: '20px', marginTop: '1px' }}>
									{moment(ticketDetails?.dt).format('HH:MM a DD-MM-YY  ')}
								</p>
							</div>
							<br />
							<br />
						</DialogContent>

						<DialogActions>
						</DialogActions>
					</Dialog>
				</ClickAwayListener>
			</div>
		</>
	);
}
